import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Header1 } from "@/components/ui/header";
import { Hero } from "@/components/ui/animated-hero";
import { MainContentSection } from "@/components/blocks/main-content-section";
import { Footer } from "@/components/ui/footer-section";
import Survey from "./pages/Survey";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Demo from "./pages/Demo";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Waitlist from "./pages/Waitlist";
import { ThemeProvider } from "./components/ui/theme-provider";
import { ScrollToTop } from "./components/ui/scroll-to-top";
import Index from "./pages/Index";

function AppContent() {
  const location = useLocation();
  const showHeaderFooter = location.pathname !== '/survey' && 
                          location.pathname !== '/waitlist' &&
                          location.pathname !== '/auth' && 
                          location.pathname !== '/dashboard' && 
                          location.pathname !== '/demo';
  const isDashboard = location.pathname === '/dashboard';

  return (
    <div className="min-h-screen font-sans antialiased overflow-x-hidden bg-background text-foreground">
      <ScrollToTop />
      {showHeaderFooter && <Header1 />}
      <div className={isDashboard ? '' : 'pt-16'}>
        <main className="relative z-0">
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/survey" element={<Survey />} />
            <Route path="/waitlist" element={<Waitlist />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            {/* Catch-all route that redirects to home page */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
      {showHeaderFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <ThemeProvider defaultTheme="dark">
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;